import * as React from 'react';
import { styled } from '@linaria/react';
import { CompactHeader } from '@daedalus/atlas/CompactHeader';
import { Text } from '@daedalus/atlas/Text';
import { useBrand } from '@daedalus/core/src/_web/brand/hooks/useBrand';
import { BrandLogo } from '@daedalus/shared/src/whiteLabel/BrandLogo/BrandLogo';
type PropsType = {
  children?: React.ReactNode;
  headerContent?: React.ReactNode;
  onBackButtonClick: () => void;
  endContent?: JSX.Element;
};
const HeaderWrapper = /*#__PURE__*/styled('div')({
  name: "HeaderWrapper",
  class: "h1ybxkbp",
  propsAsIs: false
});
const _exp2 = /*#__PURE__*/() => Text;
const HeaderContentWrapper = /*#__PURE__*/styled(_exp2())({
  name: "HeaderContentWrapper",
  class: "h3j5i26",
  propsAsIs: true
});
const OverlaySection = /*#__PURE__*/styled('section')({
  name: "OverlaySection",
  class: "outs10b",
  propsAsIs: false
});
export const MobileOverlayLayout = ({
  children,
  headerContent,
  onBackButtonClick,
  endContent = null
}: PropsType) => {
  const {
    brand
  } = useBrand();
  return <>
      <HeaderWrapper>
        <CompactHeader brand={brand} onBackButtonClick={onBackButtonClick} showStartLogo={false} hasExpandedCenterContent={!onBackButtonClick} centerContent={<HeaderContentWrapper variant="titleM">
              {headerContent}
            </HeaderContentWrapper>} BrandLogoComponent={BrandLogo} endContent={endContent} />
      </HeaderWrapper>
      <OverlaySection>{children}</OverlaySection>
    </>;
};

require("./MobileOverlayLayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./MobileOverlayLayout.tsx");